// extracted by mini-css-extract-plugin
export default {"StartWorkingWithUs":"style_StartWorkingWithUs__jR+kI","container":"style_container__nV5Jf","textBackground":"style_textBackground__H0eA8"};